<template>
  <v-card flat class="pa-4">
    <v-switch v-model="preferences.mashDuration" label="Track duration to prepare mash" dense/>
    <v-switch v-model="preferences.mashIncomplete" label="Allow incomplete mashes" dense/>
    <v-switch v-model="preferences.mashpH" label="Track pH and Specific Gravity" dense/>
    <v-switch v-model="preferences.mashBrix" label="Use Brix instead of Specific Gravity for mashing" dense/>
    <v-switch v-model="preferences.mashLot" label="Allow mash lot to be specified" dense/>
    <v-row dense class="mt-4">
      <v-col cols="3 pt-3">Numbering</v-col>
      <v-col cols="3">
        <v-text-field label="Prefix" v-model="preferences.numberPrefix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <v-text-field label="Suffix" v-model="preferences.numberSuffix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <decimal-number-input label="Start at" v-model="preferences.numberStart" :precision="0" integer prefix=""/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'ProductionMashingPreferences',
  data() {
    return {
      preferences: {}
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation ProductionMashingPreferences($input:MashingPreferencesInput!) {
                                              mashingSetPreferences(input:$input) {
                                                mashBrix, mashDuration, mashIncomplete, mashpH, mashLot
                                                numberPrefix, numberSuffix, numberStart
                                              }
                                            }`,
                                            {input:this.preferences});
        if (!results.error)
          this.$emit('update', results.data.mashingSetPreferences)
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query ProductionMashingPreferences {
                                          mashingPreferences {
                                            mashBrix, mashDuration, mashIncomplete, mashpH, mashLot
                                            numberPrefix, numberSuffix, numberStart
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.mashingPreferences;
  }
}
</script>